import { useCallback, useEffect, useLayoutEffect, useState } from 'react';

// Mede o elemento ativo (`selector`) dentro de `ref` e devolve { x, y, w, h } (ou null).
// Use para um indicador absoluto que desliza com transform/width entre as opções.
// `watchKey`: string que muda quando o ativo ou o conjunto de opções muda.
// Remede também quando o container ou os filhos mudam de tamanho (fonte, quebra de linha).
export function useSlidingIndicator(ref, selector, watchKey) {
  const [rect, setRect] = useState(null);

  const measure = useCallback(() => {
    const el = ref.current?.querySelector(selector);
    setRect((prev) => {
      if (!el) return null;
      const next = {
        x: el.offsetLeft,
        y: el.offsetTop,
        w: el.offsetWidth,
        h: el.offsetHeight,
      };
      return prev &&
        prev.x === next.x &&
        prev.y === next.y &&
        prev.w === next.w &&
        prev.h === next.h
        ? prev
        : next;
    });
  }, [ref, selector]);

  useLayoutEffect(measure, [measure, watchKey]);

  useEffect(() => {
    const container = ref.current;
    if (typeof ResizeObserver === 'undefined' || !container) return undefined;
    const observer = new ResizeObserver(measure);
    observer.observe(container);
    Array.from(container.children).forEach((child) => observer.observe(child));
    return () => observer.disconnect();
  }, [ref, measure, watchKey]);

  return rect;
}
